export default "__VITE_ASSET__CYsphiLl__"